export function splitWords(el, offset = 0) {
  let wordIndex = offset

  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent
      if (!text.trim()) return

      const parts = text.split(/(\s+)/)
      const fragment = document.createDocumentFragment()

      parts.forEach(part => {
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part))
        } else if (part) {
          const wrap = document.createElement('span')
          wrap.className = 'tt-wrap'
          const word = document.createElement('span')
          word.className = 'tt-word'
          word.style.setProperty('--i', wordIndex++)
          word.textContent = part
          wrap.appendChild(word)
          fragment.appendChild(wrap)
        }
      })

      node.parentNode.replaceChild(fragment, node)
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      Array.from(node.childNodes).forEach(processNode)
    }
  }

  Array.from(el.childNodes).forEach(processNode)
}

export function observeSplitReveal(el) {
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      el.classList.add('is-visible')
      observer.disconnect()
    }
  }, { threshold: 0.15 })
  observer.observe(el)
}
